var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "el-core__header__left header-container" }, [
    _c(
      "div",
      { staticClass: "emd-sidemenu__trigger" },
      [
        _c("button-menu", {
          attrs: { btnMenuState: _vm.isOpen },
          on: { btnMenuClicked: _vm.toggleAppMenu },
        }),
      ],
      1
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.closeDropdown,
            expression: "closeDropdown",
          },
        ],
        staticClass: "emd-control",
        class: _vm.classList,
        attrs: { "data-onboarding": "navigation" },
      },
      [
        _c(
          "div",
          { staticClass: "emd-control__wrapper" },
          [
            _c("span", { staticClass: "emd-control__status status" }, [
              _vm._v(" " + _vm._s(_vm.$t(_vm.status.label)) + " "),
            ]),
            _c("div", { staticClass: "emd-control__link" }, [
              _c(
                "div",
                { staticClass: "emd-control__icon header-icon" },
                [
                  _c("logo-stone-rebrand-icon", {
                    staticClass: "stone-rebrand-logo",
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "eu-display_flex eu-column company-container" },
                [
                  _vm.accountName
                    ? _c(
                        "span",
                        {
                          staticClass: "company-name",
                          attrs: { id: "accountName" },
                        },
                        [_vm._v(" " + _vm._s(_vm.accountName) + " ")]
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "company-document",
                      attrs: { title: _vm.companyDocument },
                    },
                    [_vm._v(" " + _vm._s(_vm.companyDocument) + " ")]
                  ),
                ]
              ),
            ]),
            _c(
              "emd-tippy",
              {
                attrs: {
                  id: "account",
                  type: "ghost",
                  position: "left",
                  content: _vm.$t("tooltip.account"),
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "emd-action-button header-button",
                    on: { click: _vm.contextDropdown },
                  },
                  [_c("emerald-icon", { attrs: { icon: "direction" } })],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "header-dropdown emd-control__dropdown jsControlAccDropdown",
          },
          [_c("app-context-select")],
          1
        ),
      ]
    ),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "eu-ml_4 eu-display_none eu-display_block_md" },
      [_c("div", { staticClass: "emd-logo-custom__image" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }